class Globals {

    static domainReplace(str) {
        return str.replace(/(http|https):\/\/foodsafetymantra.in/ig, 'https:\/\/www.foodsafetymantra.com') || str
    }

}
export default Globals
